// Loader Component
import React from 'react';

const Loader = () => {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <div className="relative w-12 h-12">
        {' '}
        {/* Reduced size */}
        <div className="absolute w-12 h-12 rounded-full border-t-4 border-[#FF7E00] border-solid animate-spin"></div>{' '}
      </div>
    </div>
  );
};

export default Loader;
